module.exports = __webpack_public_path__ + "img/matsuri_roulette_anime.e06f77c7.gif";